import styled from "styled-components";
import { useSettingsStorageContext } from "./ContextLayer/SettingsStorageProvider";

const StrengthAtom = styled.span`
    display: flex;
    flex-direction: row;
    gap: 3px;
`

const Dot = styled.div<{$filled: boolean, $darkMode: boolean}>`
    width: 5px;
    height: 5px;
    background-color: ${props => props.$darkMode ? 'rgba(255, 255, 255, 0.6)' : '#FF7300'};
    border-radius: 10px;
    opacity: ${props => props.$filled ? '1.0' : '0.26'};
    // transition: background-color var(--transition-duration-slow);
`

type StrengthProps = {
    value: number
}

export default function Strength({ value }: StrengthProps) {
    const { settings } = useSettingsStorageContext();
    const Dots = [];

    for(let i=0; i<5; i++) Dots.push(<Dot $darkMode={settings.darkMode} key={`${i}`} $filled={ value > i }/>);

    return (<StrengthAtom>{Dots}</StrengthAtom>)
}